import { render, staticRenderFns } from "./DialogScartati.vue?vue&type=template&id=611a4e1f&scoped=true&"
import script from "./DialogScartati.vue?vue&type=script&lang=js&"
export * from "./DialogScartati.vue?vue&type=script&lang=js&"
import style0 from "./DialogScartati.vue?vue&type=style&index=0&id=611a4e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a4e1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('611a4e1f')) {
      api.createRecord('611a4e1f', component.options)
    } else {
      api.reload('611a4e1f', component.options)
    }
    module.hot.accept("./DialogScartati.vue?vue&type=template&id=611a4e1f&scoped=true&", function () {
      api.rerender('611a4e1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogScartati.vue"
export default component.exports